export default __webpack_public_path__ + "static/typography-styles-3743889c0318f9bdda27a36547e08de39241c41158906ab6114a614fa08162c1.png";